import { Switch } from 'antd';

type MultipleSwitchesControlParams = {
  value?: string[];
  onChange?: (values: string[]) => void;
  values?: string[];
  showAll?: boolean;
  disabled?: boolean;
  allDisablesOthers?: boolean;
  availableValues?: string[];
};

const DEFAULT_PROPS = {
  onChange: () => {},
  value: [],
  values: ['ON', 'OFF'],
  availableValues: [],
};

export default function MultipleSwitchesControl({
  onChange = DEFAULT_PROPS.onChange,
  value = DEFAULT_PROPS.value,
  values = DEFAULT_PROPS.values,
  showAll = false,
  disabled = false,
  allDisablesOthers = true,
  availableValues = DEFAULT_PROPS.availableValues,
}: MultipleSwitchesControlParams) {
  const handleSwitchChange = (name: string, checked: boolean) => {
    const setOfValues = new Set(value);

    if (checked) {
      setOfValues.add(name);
    } else {
      setOfValues.delete(name);
    }

    if (!allDisablesOthers) {
      if (name === 'ALL') {
        onChange(checked ? ['ALL'] : []);
        return;
      }
      setOfValues.delete('ALL');
    }
    onChange(Array.from(setOfValues.values()));
  };

  return (
    <div className="flex flex-wrap gap">
      {values.map((key) => (
        <Switch
          key={key}
          title={key}
          checkedChildren={key}
          unCheckedChildren={key}
          checked={value.includes(key)}
          disabled={
            disabled || (allDisablesOthers && value.includes('ALL')) || (availableValues.length && !availableValues.includes(key)) || false
          }
          onChange={(checked) => handleSwitchChange(key, checked)}
        />
      ))}
      {showAll && (
        <Switch
          title="ALL"
          checkedChildren="ALL"
          unCheckedChildren="ALL"
          checked={value.includes('ALL')}
          disabled={disabled}
          onChange={(checked) => handleSwitchChange('ALL', checked)}
        />
      )}
    </div>
  );
}
